import { useState, useEffect } from "react";
import { loadJumboWiseProductionDetails, RefreshJumboWiseReport } from "../../services/warehouseService";

const useJumboWiseProductionDetails = () => {
    const [jumboWiseData, setJumboWiseData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch Jumbo Wise production details by date range
    const fetchJumboWiseDetails = async (fromDate, toDate) => {
        try {
            setLoading(true);
            setError(null);

            const payload = {
                p_company_id: localStorage.getItem("companyid"),
                p_plant_id: 1,
                p_from_date: fromDate,
                p_to_date: toDate,
            };

            const data = await loadJumboWiseProductionDetails(payload);

            if (data && Array.isArray(data)) {
                setJumboWiseData(data);
                setIsDataLoaded(true);
            } else {
                setJumboWiseData([]);
            }
        } catch (err) {
            console.error("Error fetching jumbo wise details:", err);
            setError(err.message);
            setJumboWiseData([]);
        } finally {
            setLoading(false);
        }
    };

    // Refresh materialized report data
    const RefreshData = async (fromDate, toDate) => {
        setLoading(true);
        try {
            const payload = {
                p_company_id: localStorage.getItem("companyid"),
                p_plant_id: 1,
            };

            // Refresh materialized data
            await RefreshJumboWiseReport(payload);

            // Then fetch the updated data
            await fetchJumboWiseDetails(fromDate, toDate);
        } catch (err) {
            console.error("Error refreshing jumbo wise data:", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Initial load on component mount
    useEffect(() => {
        if (!isDataLoaded) {
            const today = new Date().toISOString().slice(0, 10);
            const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                .toISOString()
                .slice(0, 10);
            fetchJumboWiseDetails(firstDayOfMonth, today);
        }
    }, [isDataLoaded]);

    return {
        jumboWiseData,
        setJumboWiseData,
        fetchJumboWiseDetails,
        loading,
        setLoading,
        RefreshData,
        error,
        setError,
    };
};

export default useJumboWiseProductionDetails;
